// App
export const APP_SET_LANG = 'APP_SET_LANG';

// Register
export const REGISTER_OAK_MEMBER_LOGIN_REQUEST = 'REGISTER_OAK_MEMBER_LOGIN_REQUEST';
export const REGISTER_OAK_MEMBER_LOGIN_SUCCESS = 'REGISTER_OAK_MEMBER_LOGIN_SUCCESS';
export const REGISTER_OAK_MEMBER_LOGIN_FAILURE = 'REGISTER_OAK_MEMBER_LOGIN_FAILURE';
export const REGISTER_COMPETITION_REQUEST = 'REGISTER_COMPETITION_REQUEST';
export const REGISTER_COMPETITION_SUCCESS = 'REGISTER_COMPETITION_SUCCESS';
export const REGISTER_COMPETITION_FAILURE = 'REGISTER_COMPETITION_FAILURE';
